export default "__VITE_ASSET___kacQgTT__"